const timelineContent = {
  change_action: 'Changed the Action from ',
  to: 'to',
  change_accountable: 'Changed the accountable from',
  add: 'added',
  text: 'as responsible for the Action',
  noAccountable: 'no one',
  status: 'Changed the status from',
  created: 'created the Action',
  deadLine: 'Changed the deadline from',
  change: 'modified the Action',
  no_accountable: 'No Accountable',
  removedAccountables: 'removed the accountables',
  removedAccountable: 'removed the accountable',
  addedAccountables: 'added the accountables',
  addedAccountable: 'added the accountable',
  andAdded: 'and added',
};

export default timelineContent;
